module.exports = __webpack_public_path__ + "static/media/Angola.64da816a.png";